import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';

import {
	fireFormSubmit
}
from 'voUtils/TagEx.js';

import {
	doPost
}
from 'voUtils/RestEx.js';
import {
	findPreviousSiblingByName
}
from 'voUtils/BrowserEx.js';

export default {
	voVueComponent: 'voffice-form',
	data: function () {
		var fd = VOFFICE.testmode ? {
			forename: 'John',
			surname: 'Doe',
			email: 'test@test.de',
			mobile: '342344 234234',
			message: 'Hallo World!'
		} : {};
		return {
			formData: fd,
			status: 'ready',
			error: undefined
		};
	},
	props: {
		subject: String,
		ngaction: String
	},
	mounted: function () {

		var labels = {};
		var order = [];

		this.$el.querySelectorAll('[data-formdata-field]').forEach((el) => {

			var field = el.getAttribute('data-formdata-field');

			// Feld bereits verarbeitet?
			if (order.indexOf(field) !== -1) {
				return;
			}

			var label = el.getAttribute('voffice-form-field-label');

			if (!label) {

				// 1. vorhergehendes Geschwisterelement
				var labelEl = findPreviousSiblingByName(el, 'label');

				// 2. label[for]
				if (!labelEl) {
					var id = el.getAttribute('id');

					if (id) {
						labelEl = this.$el.querySelector(
							'[for="' + id + '"]'
						);
					}
				}

				// 3. umschließendes Label
				if (!labelEl) {
					labelEl = el.closest('label');
				}

				if (labelEl) {
					label = labelEl.textContent.trim();
				}
			}

			if (label) {
				labels[field] = label;
			} else {
				console.warn(
					'could not find label for field ' + field +
					', please use label, "for" or "voffice-form-field-label" attribute'
				);
			}

			order.push(field);
		});

		this.labels = labels;
		this.order = order;
		//console.log('mounted:', this.labels);
	},
	methods: {
		submit: function () {
			this.status = 'submitting';

			var data = {
				subject: this.subject,
				form: DateEx.formatDates(this.formData, undefined, VOFFICE.mlang),
				search: DateEx.encodeDates(this.$parent.searchData),
				unit: this.$parent.getUnitId && this.$parent.getUnitId(),
				labels: this.labels,
				order: this.order
			};

			/*		console.log('FORM DATA:', data.form);
					console.log('LABELS:', data.labels);
					console.log('ORDER:', data.order);

					return; */


			fireFormSubmit(data);
			this.error = undefined;


			doPost(this.ngaction || 'saveMessage', data)
				.then((res) => {

					this.status = 'done';


				}).catch(e => {
					this.status = 'failed';
					this.error = e;
				});





		}
	}
};